import { ajax } from 'rxjs/ajax';
import * as queryString from 'query-string';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { backendApi } from './config';

export interface AjaxGet {
  url: string;
  params?: object;
}

export interface AjaxPost {
  url: string;
  body?: any;
}

export interface AjaxPatch {
  url: string;
  body?: any;
}

export interface AjaxService {
  get: (params: AjaxGet) => Observable<any>;
  post: (params: AjaxPost) => Observable<any>;
  patch: (params: AjaxPatch) => Observable<any>;
}

const ajaxService: AjaxService = {
  get: (params: AjaxGet) => {
    const paramsStr = params.params
      ? `?${queryString.stringify(params.params as any)}`
      : '';

    return ajax({
      url: `${backendApi}/${params.url}${paramsStr}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).pipe(map(response => response.response));
  },
  post: (params: AjaxPost) => {
    return ajax({
      url: `${backendApi}/${params.url}`,
      method: 'POST',
      body: params.body,
    }).pipe(map(response => response.response));
  },
  patch: (params: AjaxPatch) => {
    return ajax({
      url: `${backendApi}/${params.url}`,
      method: 'PATCH',
      body: params.body,
    }).pipe(map(response => response.response));
  },
};

export default ajaxService;



// WEBPACK FOOTER //
// ./src/services/api/ajax.ts